// 3. Ribbon.tsx
import React from "react";

export type Category = "login_logs" | "audit_logs";

interface RibbonProps {
  activeCategory: Category;
  onChange: (category: Category) => void;
}

const Ribbon: React.FC<RibbonProps> = ({ activeCategory, onChange }) => {
  const options: { id: Category; label: string }[] = [
    { id: "login_logs", label: "Καταγραφές Εισόδου (Login Logs)" },
    { id: "audit_logs", label: "Καταγραφές Ελέγχου (Audit Logs)" },
  ];

  return (
    <div className="flex bg-white border-b border-gray-200">
      {options.map((option) => (
        <button
          key={option.id}
          onClick={() => onChange(option.id)}
          className={`px-6 py-4 text-sm font-medium transition-colors ${
            activeCategory === option.id
              ? "border-b-2 border-primary text-primary"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default Ribbon;